// src/auth/tokenStore.js
// ─────────────────────────────────────────────────────────────────────────────
// Manages the JWT in localStorage under the key "wc_token".
// Exposes helpers used by AuthGate, callClaude, and fetch calls.
// ─────────────────────────────────────────────────────────────────────────────

const KEY = "wc_token";

export function saveToken(token) {
  localStorage.setItem(KEY, token);
}

export function getToken() {
  return localStorage.getItem(KEY);
}

export function clearToken() {
  localStorage.removeItem(KEY);
}

// Decode JWT payload without verifying signature (server verifies).
export function decodeToken(token) {
  if (!token) return null;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));
    // Check expiry client-side (server is authoritative, but avoids pointless requests)
    if (payload.exp && Date.now() / 1000 > payload.exp) return null;
    return payload;
  } catch {
    return null;
  }
}

// Returns the decoded payload if a valid, non-expired token exists, else null.
export function getSession() {
  return decodeToken(getToken());
}
